export const KT_I18N_CONTEXT = Symbol('KT_I18N_CONTEXT')
